module.exports = __webpack_public_path__ + "img/logo.51ad22a0.png";